export default __webpack_public_path__ + "static/social_danielle_creations-b299987887550352183baaabf85dac49.png";